var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E5AA2CB1-C312-4398-8DB4-AD3257AE812D@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Print-Receipt-by-Rev-ID---Record-Found",
    transform: "translate(-1046.000000, -232.000000)",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1058.7116,232.298256 C1058.32708,231.913728 1057.70592,231.913728 1057.32139,232.298256 L1052.5,237.109784 L1047.67861,232.288396 C1047.29408,231.903868 1046.67292,231.903868 1046.2884,232.288396 C1045.90387,232.672924 1045.90387,233.294084 1046.2884,233.678612 L1051.10978,238.5 L1046.2884,243.321388 C1045.90387,243.705916 1045.90387,244.327076 1046.2884,244.711604 C1046.67292,245.096132 1047.29408,245.096132 1047.67861,244.711604 L1052.5,239.890216 L1057.32139,244.711604 C1057.70592,245.096132 1058.32708,245.096132 1058.7116,244.711604 C1059.09613,244.327076 1059.09613,243.705916 1058.7116,243.321388 L1053.89022,238.5 L1058.7116,233.678612 C1059.08627,233.303944 1059.08627,232.672924 1058.7116,232.298256 Z",
    id: "\\uD83D\\uDD39Icon-Color"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.b06f4e187b6a1d5afafe240e1fd8f758.svg";
export { ForwardRef as ReactComponent };